import momenttz from 'moment-timezone';
import { tassign } from 'tassign';

import { PurchaseHistoryAction, PurchaseHistoryActions } from './purchase-history.actions';

export interface PurchaseHistoryState {
    tickets: any[];
    carts: any[];
    loading: boolean;
    error: any;
    startDate: Date;
    endDate: Date;
    minStartDate: Date;
    minEndDate: Date;
    maxStartDate: Date;
    maxEndDate: Date;
    diff: number;
}

export const PURCHASE_HISTORY_INITIAL_STATE: PurchaseHistoryState = {
    tickets: [],
    carts: [],
    loading: false,
    error: {},
    startDate: momenttz.tz('Europe/Tallinn').subtract(30, 'days').toDate(),
    endDate: momenttz.tz('Europe/Tallinn').toDate(),
    minStartDate: momenttz.tz('Europe/Tallinn').subtract(2, 'years').toDate(),
    minEndDate: momenttz.tz('Europe/Tallinn').subtract(2, 'years').toDate(),
    maxStartDate: momenttz.tz('Europe/Tallinn').toDate(),
    maxEndDate: momenttz.tz('Europe/Tallinn').toDate(),
    diff: 90
};

export const PURCHASE_HISTORY_STATE_KEY = 'history';

export function purchaseHistoryReducer(
    lastState: PurchaseHistoryState = PURCHASE_HISTORY_INITIAL_STATE,
    action: PurchaseHistoryAction
): PurchaseHistoryState {
    switch (action.type) {
        case PurchaseHistoryActions.FETCH_PURCHASE_HISTORY:
            return tassign(lastState, {
                loading: true
            });
        case PurchaseHistoryActions.SET_HISTORY_TICKETS:
            return tassign(lastState, {
                tickets: action.payload,
                loading: false
            });
        case PurchaseHistoryActions.SET_HISTORY_CARTS:
            return tassign(lastState, {
                carts: action.payload
            });
        case PurchaseHistoryActions.GET_HISTORY_FAILED:
            return tassign(lastState, {
                error: action.payload,
                loading: false
            });
        case PurchaseHistoryActions.SET_START_DATE: {
            const newEndDate = action.payload > lastState.endDate ? action.payload : lastState.endDate;
            return tassign(lastState, {
                startDate: action.payload,
                minEndDate: action.payload,
                endDate: newEndDate
            });
        }

        case PurchaseHistoryActions.SET_END_DATE: {
            const newStartDate = action.payload < lastState.startDate ? action.payload : lastState.startDate;
            return tassign(lastState, {
                endDate: action.payload,
                maxStartDate: action.payload,
                startDate: newStartDate
            });
        }
    }
    return lastState;
}

export interface PurchaseHistoryPartialStoreState {
    [PURCHASE_HISTORY_STATE_KEY]: PurchaseHistoryState;
}
